<template>
    <div class="request__history">
        <app-container-loading :show="isLoading" text="Carregando histórico do contato..."></app-container-loading>
        <div v-if="getRequestHistory.list.length">
            <app-perfect-scrollbar class="scrollbar">
                <div class="header" >
                    <h3 style="display: flex; align-items: center;">
                        <a href="javascript:void(0)" @click="loadRequestHistory(true)" style="margin-right: 8px; position: relative; top: 1px">
                            <i style="font-size: 24px" class="mi mi-refresh"></i>
                        </a>
                        Histórico de compras de {{ getContactName }} - {{ getTotalRequestHistory }}
                    </h3>
                </div>
                <div class="timeline">
                    <div class="entry" v-for="historyRequest of getRequestHistory.list" :key="historyRequest.id">
                        <div class="title" style="justify-content: space-between; flex-direction: column; display: flex;">
                            <div>
                                <h3>{{ historyRequest.deliveryDate ? moment(historyRequest.deliveryDate).format("DD/MM/YYYY HH:mm") : '---' }}</h3>
                                <p style="font-weight: bold;">Criado às:</p>
                                <p>{{ historyRequest.dateCreated ? moment(historyRequest.dateCreated).format("DD/MM/YYYY HH:mm") : '---' }}</p>
                                <p style="font-weight: bold;">Entregador:</p>
                                <p>{{ VXORM.User.query().find(historyRequest.deliveredBy) ? VXORM.User.query().find(historyRequest.deliveredBy).name : '---' }}</p>
                                <p style="font-weight: bold;">Finalizado às:</p>
                                <p>{{ historyRequest.deliveredDate ? moment(historyRequest.deliveredDate).format("DD/MM/YYYY HH:mm") : '---' }}</p>
                                <p>Finalizado por: {{ VXORM.User.query().find(historyRequest.finishedBy) ? VXORM.User.query().find(historyRequest.finishedBy).name : '---' }}</p>
                            </div>
                            <div 
                                v-if="VXORM.CompanyUser.hasPermission(user.id, 'request', 'edit-history')
                                    && (!request.STATE_request.hasCard || request.STATE_request.card.cardStatus === 'draft')" 
                                style="margin-top: 15px; display: flex; align-self: flex-end; flex-direction: column; justify-content: flex-end;"
                            >
                                <a href="javascript:void(0)" 
                                    @click="editOrder(historyRequest)" 
                                    class="btn btn--secondary" 
                                    style="width: 130px; background: var(--font-color); display: flex; justify-content: center;">
                                    Editar venda
                                </a>
                            </div>
                        </div>
                        <div class="body">
                            <div v-if="historyRequest.requestOrder.requestOrderProducts &&  historyRequest.requestOrder.requestOrderProducts.length" 
                                class="table" style="margin-bottom: 10px;">
                                <table style="width: 100%;">
                                    <thead>
                                    <tr>
                                        <th>Produto</th>
                                        <th>Qnt.</th>
                                        <th style="text-align: center;">Preço</th>
                                        <th style="text-align: center;">Desconto</th>
                                        <th style="text-align: right">Subtotal</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="requestOrderProduct of historyRequest.requestOrder.requestOrderProducts" :key="requestOrderProduct.id" >
                                            <td>{{ requestOrderProduct.product.name }}</td>
                                            <td style="text-align: center;">{{ requestOrderProduct.quantity }}</td>
                                            <td style="text-align: center;">{{ utils.formatMoney(requestOrderProduct.unitPrice, 2, 'R$ ', '.', ',') }}</td>
                                            <td style="text-align: center;">{{ utils.formatMoney(requestOrderProduct.unitDiscount, 2, 'R$ ', '.', ',') }}</td>
                                            <td style="text-align: right">{{ utils.formatMoney(utils.getMoneyAsDecimal((requestOrderProduct.unitPrice - requestOrderProduct.unitDiscount) * requestOrderProduct.quantity), 2, 'R$ ', '.', ',') }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="5" style="text-align: right; font-weight: bold;">
                                                {{ historyRequest.requestOrder.productsTotal }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-if="historyRequest.requestOrder.requestOrderServices &&  historyRequest.requestOrder.requestOrderServices.length" 
                                class="table" style="margin-bottom: 10px;">
                                <table style="width: 100%;">
                                    <thead>
                                    <tr>
                                        <th>Serviço</th>
                                        <th style="text-align: center;">Preço</th>
                                        <th style="text-align: center;">Desconto</th>
                                        <th style="text-align: right">Subtotal</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="requestOrderService of historyRequest.requestOrder.requestOrderServices" :key="requestOrderService.id" >
                                            <td>{{ requestOrderService.service.name }}</td>
                                            <td style="text-align: center;">{{ utils.formatMoney(requestOrderService.price, 2, 'R$ ', '.', ',') }}</td>
                                            <td style="text-align: center;">{{ utils.formatMoney(requestOrderService.discount, 2, 'R$ ', '.', ',') }}</td>
                                            <td style="text-align: right">{{ utils.formatMoney(utils.getMoneyAsDecimal(requestOrderService.price - requestOrderService.discount, 2, 'R$ ', '.', ',')) }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="5" style="text-align: right; font-weight: bold;">
                                                {{ historyRequest.requestOrder.servicesTotal }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="table">
                                <table style="width: 100%;">
                                    <thead>
                                    <tr>
                                        <th>Meio de Pag.</th>
                                        <th style="text-align: center;">Código</th>
                                        <th style="text-align: center;">Vencimento</th>
                                        <th style="text-align: center;">Pago</th>
                                        <th style="text-align: right;">Valor</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="requestOrderPayment of historyRequest.requestOrder.requestOrderPayments" :key="requestOrderPayment.id" >
                                            <td>{{ requestOrderPayment.paymentMethod.name }}</td>
                                            <td style="text-align: center;" v-if="requestOrderPayment.code">
                                                {{ requestOrderPayment.code }}
                                            </td>
                                            <td style="text-align: center;" v-else>---</td>
                                            <td style="text-align: center;" v-if="requestOrderPayment.deadlineDatetime">
                                                {{ moment(requestOrderPayment.deadlineDatetime).format("DD/MM/YYYY") }}
                                            </td>
                                            <td style="text-align: center;" v-else>---</td>
                                            <td style="text-align: center; cursor: pointer;" 
                                                :class="{ 'paid-selected': _.includes(paidsSelected, requestOrderPayment.id) }"
                                                @click="selectPaids(requestOrderPayment)">{{ (requestOrderPayment.paid) ? 'SIM' : 'NÃO'}}</td>
                                            <td style="text-align: right;">{{ utils.formatMoney(requestOrderPayment.amount, 2, 'R$ ', '.', ',') }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="5" style="text-align: right; font-weight: bold;">
                                                {{ historyRequest.requestOrder.paymentsTotal }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div style="display: flex; justify-content: flex-end;">
                                <div style="margin-top: 15px; margin-right: 5px; display: flex; flex-direction: row; justify-content: flex-end;"
                                    v-if="VXORM.CompanyUser.hasPermission(user.id, 'request-order-payment', 'pay')">
                                    <a href="javascript:void(0)"
                                        v-if="historyRequest.requestOrder.requestOrderPayments.filter(requestOrderPayment => {
                                            if(requestOrderPayment.paid) return paidsSelected.includes(requestOrderPayment.id)
                                        }).length"
                                        @click="markAsNotPaid(historyRequest.requestOrder)" class="btn btn--secondary" style="width: 100px; margin-right: 5px; background: var(--font-color); display: flex; justify-content: center;">
                                        Estornar
                                    </a>
                                    <a href="javascript:void(0)"
                                        v-if="historyRequest.requestOrder.requestOrderPayments.filter(requestOrderPayment => {
                                            if(!requestOrderPayment.paid) return paidsSelected.includes(requestOrderPayment.id)
                                        }).length"
                                        @click="markAsPaid(historyRequest.requestOrder)" class="btn btn--secondary" style="width: 100px; background: var(--font-color); display: flex; justify-content: center;">
                                        Pagar
                                    </a>
                                </div>
                                
                                <div style="margin-top: 15px; display: flex; flex-direction: column; justify-content: space-between;">
                                    <a href="javascript:void(0)" @click="copyOrder(historyRequest.requestOrder)" class="btn btn--primary" style="width: 150px; display: flex; justify-content: center;">
                                        Copiar venda
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="entry" v-if="total > offset">
                        <div class="title">
                            <a href="javascript:void(0)" @click="getRequestHistory()" style="position: relative; top: 12px;">Carregar mais</a>
                        </div>
                    </div>
                </div>
            </app-perfect-scrollbar>
        </div>
        <div v-else>
            <div class="header" >
                <h3 style="display: flex; align-items: center;">
                    {{ this.utils.isPersistedId(this.request.requestContact.contactId) ? 'Esse contato não possuí histórico de pedidos' : 'Não há nenhum contato' }}
                </h3>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapMutations, mapState, mapActions } from 'vuex'
    import _ from 'lodash'
    import Vue from 'vue'
    import shortid from 'shortid'
    import moment from 'moment'

    import ContactAPI from '../../../../../api/contacts'
    import RequestsAPI from '../../../../../api/requests'

    export default {
        props: ['request'],
        mixins: [],
        components: {
        },
        data(){
            return {
                total: 0,
                offset: 0,
                limit: 3,
                isRequesting: false,
                isLoading: false,
                paidsSelected: []
            }
        },
        computed: {
            ...mapState('auth', ['user']),
            getContactName() {
                return this.request.requestContact.contact.name
            },

            getTotalRequestHistory() {
                return this.request.STATE_request.requestHistory.total ? this.request.STATE_request.requestHistory.total : 0
            },
            getRequestHistory() {
                return this.request.STATE_request.requestHistory
            }
            
        },
        methods: {
            ...mapActions("toast", ["showToast", "showError"]),
            async loadRequestHistory(reload = false){
                if(this.utils.isPersistedId(this.request.requestContact.contactId) && !this.request.STATE_request.loadedRequestHistory || reload) {
                    this.isLoading = true
                    try {
                        const res = await ContactAPI.getRequestHistory(this.request.requestContact.contactId)
                        this.request.STATE_request.$update({
                            where: this.request.STATE_request.id,
                            data: {
                                loadedRequestHistory: true,
                                requestHistory: _.pick(res.data, ['list', 'total'])
                            }
                        })
                    } catch(err) {
                        console.log(err)
                        this.request.STATE_request.$update({
                            where: this.request.STATE_request.id,
                            data: {
                                loadedRequestHistory: false,
                                requestHistory: { list: [] }
                            }
                        })
                    }
                    this.isLoading = false
                }
            },

            async copyOrder(requestOrder) {
                console.log(requestOrder)
                let requestOrderTmpId = this.utils.isPersistedId(this.request.id) ? this.request.requestOrderId : `tmp/${shortid.generate()}`

                let requestOrderProducts = 
                    requestOrder.requestOrderProducts.length 
                    ? requestOrder.requestOrderProducts.map(requestOrderProduct => {
                        let newRequestOrderProduct = {
                            ...requestOrderProduct,
                            id: `tmp/${shortid.generate()}`,
                            requestOrderId: requestOrderTmpId
                        }
                        return newRequestOrderProduct
                    }) 
                    : [{
                        id: `tmp/${shortid.generate()}`,
                        requestOrderId: requestOrderTmpId
                    }]

                let requestOrderServices = 
                    requestOrder.requestOrderServices.length 
                    ? requestOrder.requestOrderServices.map(requestOrderService => {
                        let newRequestOrderService = {
                            ...requestOrderService,
                            id: `tmp/${shortid.generate()}`,
                            requestOrderId: requestOrderTmpId
                        }
                        return newRequestOrderService
                    }) 
                    : [{
                        id: `tmp/${shortid.generate()}`,
                        requestOrderId: requestOrderTmpId
                    }]

                let requestOrderPayments = 
                    requestOrder.requestOrderPayments.map(requestOrderPayment => {
                        let newRequestOrderPayment = {
                            ..._.pick(requestOrderPayment, ['amount', 'paymentMethodId']),
                            id: `tmp/${shortid.generate()}`,
                            requestOrderId: requestOrderTmpId
                        }
                        return newRequestOrderPayment
                    })
                requestOrder = _.assign({}, requestOrder, {
                    id: requestOrderTmpId,
                    requestOrderProducts,
                    requestOrderServices,
                    requestOrderPayments
                })
                this.request.requestOrder.deleteAllInRequestOrder()
                this.request.requestOrder.$insert({ data: requestOrder })
                this.request.$update({
                    where: this.request.id,
                    data: {
                        requestOrderId: requestOrder.id,
                        deliveryDate: null,
                        isScheduled: false
                    }
                })

                await this.$emit('updateRequestOrder', Object.assign({}, this.request, { requestOrder }))
                
                this.request.STATE_request.$update({
                    where: this.request.STATE_request.id,
                    data: {
                        activeRequestOrderTab: 'products'
                    }
                })
            },

            async editOrder(request) {
                request = this._.cloneDeep(request)
                if(!request.requestOrder.requestOrderProducts.length)
                    request.requestOrder.requestOrderProducts = [{
                        id: `tmp/${shortid.generate()}`,
                        requestOrderId: request.requestOrderId
                    }]

                if(!request.requestOrder.requestOrderServices.length)
                    request.requestOrder.requestOrderServices = [{
                        id: `tmp/${shortid.generate()}`,
                        requestOrderId: request.requestOrderId
                    }]

                this.request.deleteAllInRequest()
                this.request.$insert({
                    data: {
                        ...request,
                        requestContact: {
                            ...this.request.requestContact,
                            id: request.requestContactId
                        },
                        requestContactId: request.requestContactId
                    } 
                })

                await this.$emit('updateRequestOrder', request)

                this.request.STATE_request.$update({
                    where: this.request.STATE_request.id,
                    data: {
                        activeRequestOrderTab: 'products',
                        requestId: request.id
                    }
                })
            },

            selectPaids(requestOrderPayment) {
                if(!_.includes(this.paidsSelected, requestOrderPayment.id)) 
                    this.paidsSelected.push(requestOrderPayment.id)
                else 
                    this.paidsSelected.shift(requestOrderPayment.id)
            },

            markAsPaid(requestOrder) {
                let requestOrderPaymentIdsFiltered = requestOrder.requestOrderPayments.filter(requestOrderPayment => {
                    if(!requestOrderPayment.paid) return _.includes(this.paidsSelected, requestOrderPayment.id)
                }).map(requestOrderPayment => requestOrderPayment.id)

                if(requestOrderPaymentIdsFiltered.length)
                    RequestsAPI.markAs({
                        paidDatetime: moment().local().toISOString(),
                        requestOrderPaymentIds: requestOrderPaymentIdsFiltered
                    }, 'paid')
                        .then(() => {
                            this.loadRequestHistory(true)
                            requestOrderPaymentIdsFiltered.forEach(id => _.remove(this.paidsSelected, (paidSelected) =>  paidSelected == id))
                        })
                        .catch(err => {
                            console.err(err)
                            this.showError('Algo deu errado.')
                        }) 
                else this.showError('Você precisa selecionar algum item não pago.')
            },

            markAsNotPaid(requestOrder) {
                let requestOrderPaymentIdsFiltered = requestOrder.requestOrderPayments.filter(requestOrderPayment => {
                    if(requestOrderPayment.paid) return _.includes(this.paidsSelected, requestOrderPayment.id)
                }).map(requestOrderPayment => requestOrderPayment.id)

                if(requestOrderPaymentIdsFiltered.length)
                    RequestsAPI.markAsNot({
                        requestOrderPaymentIds: requestOrderPaymentIdsFiltered
                    }, 'paid')
                        .then(() => {
                            this.loadRequestHistory(true)
                            requestOrderPaymentIdsFiltered.forEach(id => _.remove(this.paidsSelected, (paidSelected) =>  paidSelected == id))
                        })
                        .catch(err => {
                            console.log(err)
                            this.showError('Algo deu errado.')
                        }) 
                else this.showError('Você precisa selecionar algum item pago.')
            }
        },
        mounted(){
            this.loadRequestHistory()
        }
    }
</script>

<style lang="scss" scoped>
    .request__history {
        $gutter: 20px;
        $border-width: 3px;
        $dot-diameter: 18px;
        background-color: var(--bg-color--2);
        table {
            margin: 0!important;
        }
        .scrollbar {
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
        }
        div.header {
            padding: 20px 8px;
        }
        .timeline {
            width:100%;
            padding: 20px 20px;
            position: relative;
            &:before {
                content: '';
                position: absolute;
                top: 0;
                left: 179px; //$gutter/2
                bottom: 0;
                width: $border-width;
                background: var(--font-color--primary);
            }
            &:after {
                content: "";
                display: table;
                clear: both;
            }
        }

        .entry:last-child {
            .body {
                border-bottom: 0;
            }
        }

        .entry {
            position: relative;
            display: flex;
            margin-bottom: 40px; 
            .title {
                flex-shrink: 0;
                padding-top: 5px;
                float: left;
                width: 160px;
                padding-right: $gutter;
                text-align: right;
                position: relative;
                &:before {
                    content: '';
                    position: absolute;
                    width: $dot-diameter;
                    height: $dot-diameter;
                    border: $border-width solid var(--font-color--primary);
                    background-color:#fff;
                    border-radius:100%;
                    top: 6px;
                    right: -$dot-diameter + ($dot-diameter / 2);
                    z-index: 99;
                }
                h3 {
                    margin: 0;
                    font-size: 120%;
                }
                p {
                    margin: 0;
                    font-size: 100%;
                }
            }
            .body {
                padding-left: 20px;
                padding-top: 2px;
                border-bottom: 0;
                flex-grow: 1;
                p {
                    line-height: 1.4em;
                    &:first-child {
                        margin-top: 0;
                        font-weight: 400;
                    }
                }
                ul {
                    color:#aaa;
                    padding-left: 0;
                    list-style-type: none;
                    li:before {
                        content: "–";
                        margin-right: .5em;
                    }
                }
            }
        }

    }
    .paid-selected {
        color: var(--bg-color--primary);
    }

    .no-selected-paid {
        color: white;
    }
</style>
